import React from 'react';
import { PageTitle } from '../../components';
import { TreeIntro, TreeBenefits, TreeTasks } from '../../sections';
import { useTranslation } from 'react-i18next';
import { titles } from '../../constants';

const TreePage = () => {
const t = useTranslation().t;

    return (
        <>
            <PageTitle title={t('titles.tree')} page={t('titles.subTitleTree')} />

            <div className='tree-page-wrapper'>
                <TreeIntro />
                <TreeBenefits />
                <TreeTasks />
            </div>
        </>
    );
};

export default TreePage;